import kitzLogo from "./kitz.gif";
import atamLogo from "./atam.png";
import emeraldLogo from "./emerald.png";
import easyflexLogo from "./Easyflex.png";
import anergyLogo from "./anergy.jpeg";
import castleLogo from "./castle.png";
import aerofoamLogo from "./aerofoam.jpeg";
import siemensLogo from "./Siemens.png";
import advanceLogo from "./advancevalves.png";
import trishulLogo from "./trishul.gif";
import belimoLogo from "./belimo.jpeg";
import RBLogo from "./RB.png";
import AudcoLogo from "./flowserve_audco.png";
import DanfossLogo from "./danfoss.png";
import CooperLogo from "./cooperfiresafety.jpeg";
import HGuruLogo from "./h_guru.png";
import BaumerLogo from "./Baumer.jpeg";

const logos = Object.freeze({
  kitzLogo,
  atamLogo,
  emeraldLogo,
  easyflexLogo,
  anergyLogo,
  castleLogo,
  aerofoamLogo,
});

export const otherLogos = Object.freeze({
  siemensLogo,
  advanceLogo,
  trishulLogo,
  belimoLogo,
  RBLogo,
  AudcoLogo,
  DanfossLogo,
  CooperLogo,
  HGuruLogo,
  BaumerLogo
});
export default logos;
